"use strict";

import _classCallCheck from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Stealing Hearts Site\\Stealing Hearts Git\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Coder } from "./abstract-coder";
import { pack, unpack } from "./array";
export var TupleCoder = /*#__PURE__*/function (_Coder) {
  _inherits(TupleCoder, _Coder);

  function TupleCoder(coders, localName) {
    var _this;

    _classCallCheck(this, TupleCoder);

    var dynamic = false;
    var types = [];
    coders.forEach(function (coder) {
      if (coder.dynamic) {
        dynamic = true;
      }

      types.push(coder.type);
    });
    var type = "tuple(" + types.join(",") + ")";
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TupleCoder).call(this, "tuple", type, localName, dynamic));
    _this.coders = coders;
    return _this;
  }

  _createClass(TupleCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      return pack(writer, this.coders, value);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return reader.coerce(this.name, unpack(reader, this.coders));
    }
  }]);

  return TupleCoder;
}(Coder);